import { Component } from '@angular/core';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { ResponseObject } from 'src/app/models/response-object.model';

@Component({
  selector: 'app-history-purchases-pending-receipt',
  templateUrl: './history-purchases-pending-receipt.component.html',
  styleUrls: ['./history-purchases-pending-receipt.component.scss']
})
export class HistoryPurchasesPendingReceiptComponent {
  history = 6;
  permissionType = PermissionTypeEnum;
  warehouseList: WarehouseResponse[] = [];
  warehouseNames: { [key: number]: WarehouseResponse } = [];

  constructor(
    private authService: AuthenticationService,
    private warehouseService: WarehouseService
  ) {
    var permissions = authService.getPermissions();
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        const element = permissions[i];
        if (element.roleId == 5017) {
          this.history = 0;
          break;
        } else if (element.roleId == 5023) {
          this.history = 1;
          break;
        } else if (element.roleId == 5018) {
          this.history = 2;
          break;
        }
      }
    }
  }

  ngOnInit(): void {
      this.getWarehouses();
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue("").subscribe({
      next: (response: ResponseObject) => {
        this.warehouseList = response.data;
        this.warehouseList.forEach((w) => {
          this.warehouseNames[w.id] = w;
        })
      }
    })
  }
}
